import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TableComponent } from './table.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: TableComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class TableRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/table/table-routing.module.ts